import React, { Component } from 'react';

import Dialog from '../dialog';
import DTCView from './dtcView';

import CognitoUtil from '../../../../aws/cognito/cognitoUtil';

export default class DTCHistoryModal extends Component {

    constructor() {
        super();

        this.localState = {};
    }

    queryDTCData(raven)
    {
        this.props.dataStore.getRavenDTCs(raven);
    }

    componentDidMount() {
        this.localState.ravenid = this.props.raven.item.Id;
        this.queryDTCData(this.props.raven);
    }

    componentDidUpdate() {

        if(this.props.raven && this.props.raven.item && this.props.raven.item.Id)
        {
            if(this.props.raven.item.Id !== this.localState.ravenid)
            {
                this.localState.ravenid = this.props.raven.item.Id;

                this.queryDTCData(this.props.raven);
            }
        }
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.props.raven.dtc ? 
                                        this.props.raven.dtc.length !== 0 ?  
                                            <DTCView 
                                                data={this.props.raven.dtc} 
                                                /> : 
                                            <p>No DTC Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    
                    </div>
            </Dialog>
        );
    }

}
